import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["image"];
  static values = {
    framesCount: Number,
    srcTemplate: String,
    frameStep: { type: Number, default: 1 },
  };

  connect() {
    this.currentFrame = 1;
    this.effectiveFramesCount = Math.ceil(
      this.framesCountValue / this.frameStepValue,
    );
    this.images = new Array(this.effectiveFramesCount);
    this.preloadImages();

    this.updateFrameByPosition = this.updateFrameByPosition.bind(this);

    this.element.addEventListener("mousemove", this.updateFrameByPosition);
    this.element.addEventListener("touchmove", this.updateFrameByPosition, {
      passive: true,
    });
  }

  disconnect() {
    this.element.removeEventListener("mousemove", this.updateFrameByPosition);
    this.element.removeEventListener("touchmove", this.updateFrameByPosition);
  }

  preloadImages() {
    let imageIndex = 0;
    for (let i = 1; i <= this.framesCountValue; i += this.frameStepValue) {
      const img = new Image();
      img.src = this.frameSrc(i);
      this.images[imageIndex] = img;
      imageIndex++;
    }
  }

  frameSrc(index) {
    return this.srcTemplateValue.replace("{{index}}", index);
  }

  updateFrameByPosition(event) {
    const rect = this.element.getBoundingClientRect();
    let x;
    if (event.type === "mousemove") {
      x = event.clientX - rect.left;
    } else if (event.type === "touchmove" && event.touches.length > 0) {
      x = event.touches[0].clientX - rect.left;
    } else {
      return;
    }

    const percent = x / rect.width;
    const frameIndex = Math.floor(percent * this.effectiveFramesCount);
    const clampedIndex = Math.min(
      Math.max(frameIndex, 0),
      this.effectiveFramesCount - 1,
    );

    if (clampedIndex !== this.currentFrame) {
      this.currentFrame = clampedIndex;
      const actualFrameNumber = clampedIndex * this.frameStepValue + 1;
      this.imageTarget.src = this.frameSrc(actualFrameNumber);
    }
  }
}
